module.exports = __webpack_public_path__ + "media/images/new/icons/li_steps_header-active-1843de2c0750dc38a7e8cb70f9dcfd07.png";